module.exports = __webpack_public_path__ + "img/map_dark_24dp.03eea146.svg";